// extracted by mini-css-extract-plugin
module.exports = {"tooltipDropdown":"TextColourPicker_tooltipDropdown__8CWnf","colorPicker":"TextColourPicker_colorPicker__3OjeG"};